/* ==========================================================
   Jullens – tabletmodus op de productpagina (route a, personaliseren met Globo)
   Hoort in: assets/jullens-tablet-product.js – geladen via snippets/jullens-tablet-product.liquid (alleen productpagina).

   Werkt UITSLUITEND in een bewust gestarte tabletflow:
   - de winkelmodule zet in sessionStorage (alleen dit tabblad) een ticket { nonce, handle, verloopt, terug, toestand:'open' }
   - en opent /products/<handle>?jullens_tablet=<nonce>.
   Alleen als URL-nonce, ticket, handle en tijd kloppen, doet dit script iets. Voor elke andere bezoeker stopt het direct:
   de gewone webshop (Globo, staffelomleiding, winkelwagen, checkout) blijft precies zoals hij is.

   In tabletmodus:
   - balk bovenin "Annuleren – terug naar de bestelling"; tabletmodus eindigt bij annuleren, terug en na toevoegen;
   - aantal vast op 1 (alleen om te personaliseren; het echte aantal zet de winkelmodule): de staffelomleiding start nooit;
   - geen weg naar de gewone winkelwagen of checkout (links en snelle-betaalknoppen geblokkeerd);
   - Globo vult de winkelwagen zoals altijd (keuzes, tekst, upload, meerprijs); direct na een geslaagde toevoeging terug
     naar de winkelmodule, die controleert dat er precies één regel bij kwam;
   - ontbreekt een verplichte upload (Globo-upload mislukt of niet gekozen), dan wordt niets toegevoegd en volgt een melding.
   ========================================================== */
(function () {
  'use strict';
  var TICKET = 'jullens_tablet_product', MAX_MS = 15 * 60000;
  var UPLOAD_RE = /^https:\/\/option\.nyc3\.digitaloceanspaces\.com\/uploads\//;
  function lees() { try { return JSON.parse(sessionStorage.getItem(TICKET) || 'null'); } catch (e) { return null; } }
  function zet(t) { try { if (t) sessionStorage.setItem(TICKET, JSON.stringify(t)); else sessionStorage.removeItem(TICKET); } catch (e) {} }
  var params; try { params = new URLSearchParams(location.search); } catch (e) { return; }
  var nonce = params.get('jullens_tablet');
  if (!nonce) return;                                                     // gewone bezoeker: niets doen
  var t = lees();
  var handle = (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1] || '';
  if (!t || t.nonce !== nonce || t.toestand !== 'open' || t.handle !== decodeURIComponent(handle) || !(Date.now() < t.verloopt) || (t.verloopt - t.start) > MAX_MS) return;
  if (!/^\/pages\/[a-z0-9-]+$/.test(t.terug || '')) return;               // terugadres alleen binnen de eigen winkel
  window.JullensTabletProduct = { actief: true, versie: 1 };

  function naarTerug(toestand, extra) {
    var x = lees(); if (x && x.nonce === nonce) { x.toestand = toestand; if (extra) for (var k in extra) x[k] = extra[k]; zet(x); }
    (window.__jtpNaar || function (u) { location.replace(u); })(t.terug + '?jullens_tablet_terug=' + encodeURIComponent(nonce));   // __jtpNaar: alleen voor de lokale test
  }

  /* ---------- balk + stijl ---------- */
  var css = document.createElement('style');
  css.textContent = '#jtp-balk{position:fixed;top:0;left:0;right:0;z-index:2147483000;background:#2f3e3a;color:#fff;font:600 16px/1.3 system-ui,sans-serif;display:flex;gap:12px;align-items:center;justify-content:space-between;padding:10px 14px}' +
    '#jtp-balk button{font:600 16px system-ui,sans-serif;border:0;border-radius:8px;padding:10px 16px;background:#B8923A;color:#fff}' +
    '#jtp-melding{position:fixed;left:50%;top:70px;transform:translateX(-50%);z-index:2147483001;background:#b3261e;color:#fff;font:600 16px system-ui,sans-serif;padding:12px 16px;border-radius:8px;max-width:90%;display:none}' +
    'body{padding-top:62px!important}.shopify-payment-button,[data-shopify="payment-button"],.cart-notification,cart-notification,cart-drawer{display:none!important}' +
    '.jtp-verborgen{display:none!important}';
  document.head.appendChild(css);
  function melding(tekst) { var m = document.getElementById('jtp-melding'); if (!m) return; m.textContent = tekst; m.style.display = 'block'; clearTimeout(melding.t); melding.t = setTimeout(function () { m.style.display = 'none'; }, 6000); }
  function bouwBalk() {
    if (document.getElementById('jtp-balk')) return;
    var b = document.createElement('div'); b.id = 'jtp-balk';
    b.innerHTML = '<span>Tablet – personaliseren voor de bestelling (het aantal regelt u straks in de winkelmodule)</span><button type="button" id="jtp-terug">Annuleren – terug naar de bestelling</button>';
    document.body.appendChild(b);
    var m = document.createElement('div'); m.id = 'jtp-melding'; document.body.appendChild(m);
    document.getElementById('jtp-terug').addEventListener('click', function () { naarTerug('geannuleerd'); });
  }

  /* ---------- aantal vast op 1 ---------- */
  /* Alleen iets wijzigen als het nog niet goed staat: andere scripts op de pagina (thema, staffelomleiding) reageren op
     wijzigingen; telkens opnieuw zetten gaf in de browserproef een eindeloze lus (pagina bevroor). */
  /* Vast aantal = het minimum van het product (min-attribuut van het aantalveld, anders 1). Browserproef 08-10: met 1 bij
     een product met minimum 25 bleef het thema hangen (ongeldig formulier). Het echte aantal zet de winkelmodule. */
  function vastWaarde(q) { var m = parseInt(q.getAttribute('min') || '1', 10); return String(m > 0 ? m : 1); }
  function vastAantal() {
    Array.prototype.forEach.call(document.querySelectorAll('input[name="quantity"]'), function (q) {
      var w = vastWaarde(q);
      if (q.value !== w) q.value = w;
      if (q.getAttribute('value') !== w) q.setAttribute('value', w);
      if (!q.readOnly) q.readOnly = true;
      var houder = q.closest('quantity-input, .quantity, .product-form__quantity, .product__quantity') || q.parentElement;
      if (houder && !houder.classList.contains('jtp-verborgen')) houder.classList.add('jtp-verborgen');
    });
  }
  var vastGepland = false;
  function vastAantalUitgesteld() { if (vastGepland) return; vastGepland = true; setTimeout(function () { vastGepland = false; vastAantal(); }, 50); }
  document.addEventListener('change', function (e) { if (e.target && e.target.name === 'quantity' && e.target.value !== vastWaarde(e.target)) { e.stopImmediatePropagation(); e.target.value = vastWaarde(e.target); } }, true);
  document.addEventListener('input', function (e) { if (e.target && e.target.name === 'quantity' && e.target.value !== vastWaarde(e.target)) { e.stopImmediatePropagation(); e.target.value = vastWaarde(e.target); } }, true);

  /* ---------- geen weg naar winkelwagen/checkout/kortingstrechter ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('a[href]');
    if (!a) return;
    var h = a.getAttribute('href') || '';
    if (/^\/(cart|checkout|checkouts)\b|\/pages\/(bestelling-afronden|kortingstrechter)/.test(h) || /\/(cart|checkout)(\/|$|\?)/.test(h)) {
      e.preventDefault(); e.stopImmediatePropagation(); melding('In tabletmodus gaat u terug via "Annuleren" of door toe te voegen.');
    }
  }, true);

  /* ---------- upload verplicht? ---------- */
  /* De gekozen variant komt uit het verborgen veld "id" + de productgegevens (niet uit losse keuzevelden: op sommige
     pagina's blijft een verborgen keuzelijst op een oude waarde staan). Pas als dat niet lukt: de zichtbare keuzes. */
  var variantTitels = {};
  try { origFetchVoorProduct('/products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (p) { (p.variants || []).forEach(function (v) { variantTitels[String(v.id)] = String(v.title || ''); }); }).catch(function () {}); } catch (e) {}
  function origFetchVoorProduct(u) { return (window.fetch)(u, { headers: { Accept: 'application/json' } }); }
  function gekozenVariantTekst(form) {
    var id = form && form.querySelector('[name="id"]');
    if (id && variantTitels[String(id.value)]) return variantTitels[String(id.value)].toLowerCase();
    var tekst = [];
    Array.prototype.forEach.call(form ? form.querySelectorAll('input[type="radio"]:checked, select') : [], function (x) { if (x.name !== 'id') tekst.push(x.value); });
    return tekst.join(' / ').toLowerCase();
  }
  function uploadNodig(form) {
    var heeftUploadVeld = !!document.querySelector('.gpo-app input[type="file"], .gpo-container input[type="file"]');
    if (!heeftUploadVeld) return false;
    var v = gekozenVariantTekst(form);
    if (/alleen tekst|(^|\W)nee(\W|$)/.test(v)) return false;
    return /foto|logo/.test(v);
  }
  function heeftUpload(form) {
    var velden = document.querySelectorAll('input, textarea');   // naam begint met "properties[" (zonder [-selector: robuuster)
    for (var i = 0; i < velden.length; i++) if (String(velden[i].name || '').indexOf('properties[') === 0 && UPLOAD_RE.test(String(velden[i].value || ''))) return true;
    return false;
  }
  function magToevoegen(form) {
    if (uploadNodig(form) && !heeftUpload(form)) { melding('De foto of het logo is nog niet (goed) geüpload. Kies het bestand opnieuw en wacht tot het klaar is.'); return false; }
    return true;
  }

  /* ---------- toevoegen volgen ---------- */
  var bezig = false;
  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = String((input && input.url) || input || '');
    var isAdd = /\/cart\/add(\.js)?(\?|$)/.test(url);
    var p = origFetch.apply(this, arguments);
    if (!isAdd) return p;
    bezig = true;
    return p.then(function (res) {
      bezig = false;
      var q = document.querySelector('input[name="quantity"]');
      if (res && res.ok) setTimeout(function () { naarTerug('toegevoegd', { toegevoegdOp: Date.now(), aantalPagina: q ? parseInt(vastWaarde(q), 10) : 1 }); }, 0);
      else melding('Toevoegen is niet gelukt. Controleer de keuzes en probeer opnieuw.');
      return res;
    }, function (err) { bezig = false; melding('Toevoegen is niet gelukt (geen verbinding). Probeer opnieuw.'); throw err; });
  };
  // controle vóór Globo/thema (capture): ontbreekt de upload, dan gaat er niets naar de winkelwagen
  document.addEventListener('click', function (e) {
    var k = e.target && e.target.closest && e.target.closest('button[name="add"], [type="submit"][name="add"], .product-form__submit');
    if (!k) return;
    var form = k.closest('form');
    if (!magToevoegen(form)) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);
  document.addEventListener('submit', function (e) {
    var f = e.target; if (!f || !/\/cart\/add/.test(f.getAttribute('action') || '')) return;
    if (!magToevoegen(f)) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);
  // vangnet: verstuurt het thema het formulier gewoon (zonder fetch), dan zelf via fetch – nooit naar /cart
  window.addEventListener('submit', function (e) {
    var f = e.target; if (!f || !/\/cart\/add/.test(f.getAttribute('action') || '') || e.defaultPrevented) return;
    e.preventDefault();
    if (bezig) return;
    window.fetch('/cart/add.js', { method: 'POST', body: new FormData(f), headers: { Accept: 'application/json' } });
  });

  // verlopen terwijl de pagina open staat
  setInterval(function () { if (!(Date.now() < t.verloopt)) naarTerug('verlopen'); }, 15000);

  function start() { bouwBalk(); vastAantal(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  new MutationObserver(vastAantalUitgesteld).observe(document.documentElement, { childList: true, subtree: true });
})();
/* Versie 4 – 08-10-2026 – assets/jullens-tablet-product.js – vast aantal = productminimum (min-attribuut), aantalPagina in ticket (browserproef: met 1 bleef het thema hangen bij minimum 25). Versie 3: aantal vastzetten alleen bij afwijking en uitgesteld (browserproef: eindeloze lus met thema/staffelscript). Versie 2: gekozen variant uit veld id + productgegevens (niet uit verouderde keuzelijst). Vorige: Versie 1 – 08-10-2026 – tabletmodus productpagina (route a): alleen met geldig ticket; aantal 1; terug na toevoegen; upload verplicht bij foto/logo */
